<template>
  <b-modal :active.sync="isModalActive" has-modal-card>
    <div class="modal-card" style="width: auto">
      <header class="modal-card-head" v-if="$slots.header">
        <slot name="header"></slot>
      </header>
      <header class="modal-card-head" v-if="$slots.title">
        <p class="modal-card-title">
          <slot name="title"></slot>
        </p>
      </header>
      <section class="modal-card-body">
        <slot name="body"></slot>
        <slot></slot>
      </section>
      <footer class="modal-card-foot" v-if="$slots.footer">
        <slot name="footer"></slot>
      </footer>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'ModalCard',
  props: {
    isOpen: Boolean
  },
  data () {
    return {
      isModalActive: false
    }
  },
  methods: {
    open () {
      this.isModalActive = true
    },
    close () {
      this.isModalActive = false
    }
  },
  created () {
    // open on load?
    if (this.isOpen) {
      this.open()
    }
  }
}
</script>
